console.log("Jaichand");
function changeItemQtyPaddle(variantId, needQtyInCart, currentQtyInCart) {
  var data = { id: variantId, quantity: needQtyInCart };

  // If the product is a trial and the quantity is more than 1, set the quantity to 1
  if (variantId === '47920261202236' && needQtyInCart > 1) {
    needQtyInCart = 1;
  }

  $.ajax({
    url: '/cart/change.js',
    type: 'POST',
    data: data,
    dataType: 'json',
    success: function (cart) {
      console.log("added");
    }
  });
}

function removeExtraTrial() {
  var sampleTrial = '47920261202236';
  var totalsample = 0;

  jQuery.getJSON('/cart.js', function (cart) {
    let items = cart.items;
    if (items.length > 0) {
      for (var i = 0; i < items.length; i++) {
        var variant_id = items[i].variant_id;
        var variant_qty = items[i].quantity;

        if (variant_id == sampleTrial && variant_qty > 1) {
          totalsample = variant_qty;
          // Change the quantity to 1 for the trial product
          changeItemQtyPaddle(variant_id, 1, variant_qty);
        }
      }

      if (totalsample) {
        // Change the quantity to 1 for the trial product
        changeItemQtyPaddle(sampleTrial, 1, totalsample);
      }
    }
  });
}